module.exports = __webpack_public_path__ + "static/img/file-blue.11d19b7d.svg";